export default __webpack_public_path__ + "static/media/chapterLock.98436e20.svg";